import { render, staticRenderFns } from "./BaseDetailsModal.vue?vue&type=template&id=b0d4efe6&scoped=true&"
import script from "./BaseDetailsModal.vue?vue&type=script&lang=js&"
export * from "./BaseDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d4efe6",
  null
  
)

export default component.exports